import domElementsFound from 'DOM/domElementsFound';
import setElementHeight from 'DOM/setElementHeight';
import throttle from 'lodash.throttle';

const selectors = {
  card: '[data-card-component]',
  cardLink: '[data-card-link]',
  cardImage: '[data-card-image]',
  cardImageWrapper: '[data-card-image-wrapper]',
};

/**
 * Sets aspect ratio on media card image wrapper (tall or square)
 * This fixes an issue caused by Shopify's crop filters failing
 * if an image's intrinsic dimensions aren't large enough for the
 * requested crop
 */
const setImageAspectRatio = (images) => {
  if (!domElementsFound(images)) return;

  images.forEach((image) => {
    const { aspectRatio } = image.dataset;

    if (!aspectRatio) return;

    const wrapper = image.closest(selectors.cardImageWrapper);
    const wrapperWidth = wrapper.offsetWidth;
    const aspectRatioMap = {
      square: 1,
      tall: 1.2820512821,
      wide: 0.75,
    };

    const newHeight = wrapperWidth * aspectRatioMap[aspectRatio];

    setElementHeight(wrapper, newHeight);
  });
};

/**
 * Initializes click listener and pointer style on inclusive card component
 * @param {NodeList} cards
 */
const supressLinksOnLongMouseDown = (cards) => {
  if (!domElementsFound(cards)) return;

  Array.from(cards).forEach((card) => {
    const cardElement = card;
    cardElement.style.cursor = 'pointer';

    let down;
    let up;
    const link = cardElement.querySelector(selectors.cardLink);

    cardElement.onmousedown = () => {
      down = +new Date();
    };

    cardElement.onmouseup = (event) => {
      up = +new Date();
      const targetType = event.target.nodeName.toLowerCase();
      if (up - down < 200 && targetType !== 'button') {
        link.click();
      }
    };
  });
};

const mediaCard = {
  init: () => {
    const cardElements = document.querySelectorAll(selectors.card);
    if (!domElementsFound(cardElements)) return;
    supressLinksOnLongMouseDown(cardElements);

    const imageElements = document.querySelectorAll(selectors.cardImage);

    if (domElementsFound(imageElements)) {
      setImageAspectRatio(imageElements);
      window.addEventListener(
        'resize',
        throttle(() => {
          setImageAspectRatio(imageElements);
        }, 500)
      );
    }
  },
};

mediaCard.init();

export default mediaCard;
